import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { MessageSeverity } from "primereact/api";
import { Message } from "primereact/message";

import { faCheck, faCircleInfo, faCircleXmark, faTriangleExclamation } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { TextMarkdown } from "../../../components/Shared/Components";
import { IChatExchangeError } from "../../../models/interfaces/chat-exchange-error.interface";
import { useStore } from "../../../stores/StoreContext";

import "./ExchangeErrors.scss";

const RawExchangeErrorsComponent: FunctionComponent = () => {
  const { t } = useTranslation();
  const { threadStore } = useStore();

  const errorIconMap: any = {
    [MessageSeverity.ERROR]: faCircleXmark,
    [MessageSeverity.WARN]: faTriangleExclamation,
    [MessageSeverity.INFO]: faCircleInfo,
    [MessageSeverity.SUCCESS]: faCheck,
  };

  const content = (threadError: IChatExchangeError) => (
    <div className="thread-exchange-error">
      <div className="thread-exchange-error-icon">
        <FontAwesomeIcon icon={errorIconMap[threadError.severity]} />
      </div>

      <div className="thread-exchange-error-content">
        <div className="thread-exhcange-error-label">{t(threadError.messageTranslationKey)}</div>

        {threadError.messageDescriptionTranslationKey && (
          <div className="thread-exchange-error-description">
            {threadError.isDescriptionMarkdown && (
              <TextMarkdown>{t(threadError.messageDescriptionTranslationKey)}</TextMarkdown>
            )}

            {!threadError.isDescriptionMarkdown && <div>{t(threadError.messageDescriptionTranslationKey ?? "")}</div>}
          </div>
        )}
      </div>
    </div>
  );

  if (!threadStore.threadErrors?.length) {
    return;
  }

  return (
    <div className="thread-exchange-errors">
      {threadStore.threadErrors.map((threadError, index) => (
        <Message key={index} severity={threadError.severity} content={content(threadError)} />
      ))}
    </div>
  );
};

export const ExchangeErrorsComponent = observer(RawExchangeErrorsComponent);
